































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import GoodsApi from '@/api/goods/list'
import distributorApi from '@/api/distributor/index.ts'
import appconst from '@/lib/appconst'
import EmployeeApi from '@/api/employee/index.ts'
import CouponSelect from "@/components/coupon-select/index.vue";

@Component({
  components: {
    CustomForm,
    CouponSelect
  },
})
export default class DistributorList extends AbpBase {
  templateUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/Employee/TemplateFile`
  uploadUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/Employee/excel/upload`

  filters = [
    {
      label: '姓名：',
      type: 'input',
      props: {
        placeholder: '请输入分销员姓名',
      },
      key: 'Name',
    },
    {
      label: '注册时间：',
      type: 'daterange',
      key: 'date',
      defaultValue: '',
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '姓名',
      key: 'name',
      align: 'center',
      width: 100,
    },
    {
      title: '导购编码',
      align: 'center',
      key: 'employeeCode',
      width: 100,
    },
    {
      title: '身份证号码',
      align: 'center',
      width: 160,
      key: 'idCard',
    },
    {
      title: '手机号',
      align: 'center',
      key: 'phoneNumber',
      width: 120,
    },
    {
      title: '职位',
      align: 'center',
      key: 'position',
      width: 120,
    },
    {
      title: '所属办事处',
      align: 'center',
      key: 'department',
      width: 200,
    },
    {
      title: '店铺编码',
      align: 'center',
      key: 'shopCode',
      width: 120,
    },
    {
      title: '昵称',
      align: 'center',
      key: 'nickName',
      width: 100,
    },
    {
      title: '会员号',
      align: 'center',
      key: 'code',
      width: 120,
    },
    {
      title: '会员等级',
      align: 'center',
      key: 'level',
      width: 100,
    },
    {
      title: '积分',
      align: 'center',
      key: 'bonus',
      width: 80,
    },
    {
      title: '绑定时间',
      slot: 'creationTime',
      key: 'creationTime',
      align: 'center',
      width: 140,
    },
    {
      title: '累计订单金额',
      align: 'center',
      key: 'amountDistribution',
      width: 120,
    },
    {
      title: '累计收益金额',
      align: 'center',
      key: 'totalIncome',
      width: 120,
    },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center',
    },
  ]
  isCheckAll: boolean = false
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  tabList = ['全部', '待审核', '已通过', '未通过']
  activeTab = 0
  showModal = false
  showCouponModal = false

  verify = {
    reviewStatus: 1,
    failReason: null,
  }
  couponConfigForm = {
    coupons: []
  }
  ruleVerify = {
    failReason: [{ required: true, validator: this.validateRemark, trigger: 'blur' }],
  }
  verifyId = null
  loadingBtn = false

  get transcolums() {
    return [
      {
        title: "优惠券名称",
        key: "couponName"
      },
      {
        title: "数量",
        key: "quantity",
        width: 150,
        render: (h, params) => {
          return h("InputNumber", {
            props: {
              value: this.couponConfigForm.coupons[params.index] ? this.couponConfigForm.coupons[params.index].quantity : 0,
              min: 1
            },
            on: {
              "on-change": (event: number) => {
                this.couponConfigForm.coupons[params.index].quantity = event;
              }
            }
          });
        }
      },
      {
        title: "操作",
        key: "action",
        slot: "action",
        width: 150,
      }
    ]
  }

  validateRemark(rule, value, callback) {
    if (this.verify.reviewStatus == 2 && !value) {
      return callback(new Error('请输入备注'))
    }
    callback()
  }

  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  mounted() {
    this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  getTableData(form = {}) {
    this.isCheckAll = false
    let Name = form['Name']
    let dateList = form['date']
    let StartTime = dateList[0] ? this.dateString(dateList[0]) : null
    let EndTime = dateList[1] ? this.dateString(dateList[1]) : null
    let { pageSize, currentPage, activeTab } = this
    let ReviewStatus = activeTab == 0 ? null : activeTab - 1
    distributorApi
      .getdistributionList1(pageSize, currentPage, Name, ReviewStatus, StartTime, EndTime)
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
        // console.log('啦啦啦', res);
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  couponSelectChange(list) {
    this.couponConfigForm.coupons = this.couponConfigForm.coupons.concat(
      list.map(x => {
        let item = {
          couponId: x.id,
          couponName: x.name,
          couponType: x.couponType,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          value: x.discountValue,
          quantity: 1
        };
        return item;
      })
    );
  }
  // 删除优惠券
  removeCoupon(index) {
    this.couponConfigForm.coupons.splice(index, 1)
  }
  // 券包保存
  saveCouponConfigFn() {
    if(!this.couponConfigForm.coupons.length) {
      this.$Notice.warning({ title: '请先选择优惠券' })
      return
    }
    distributorApi.distributorCouponConfig(this.verifyId, this.couponConfigForm).then(res => {
      this.$Notice.success({ title: '配置成功' })
      this.showCouponModal = false
    })
  }
  showModalFn(row) {
    this.verifyId = row.id
    this.showModal = true
  }
  couponConfig(row) {
    this.verifyId = row.id
    this.showCouponModal = true
  }
  /**
   * 提交审核
   */
  saveFn() {
    let verifyForm: any = this.$refs.verifyForm
    verifyForm.validate((valid) => {
      if (valid && this.verifyId) {
        this.loadingBtn = true
        distributorApi
          .verifyDistributionInfo(this.verifyId, this.verify)
          .then((res) => {
            this.cancelFn()
            this.submitFn()
          })
          .catch((err) => {
            this.loadingBtn = false
          })
      }
    })
  }

  /**
   * 取消审核
   */
  cancelFn() {
    this.showModal = false
    this.verify = {
      reviewStatus: 1,
      failReason: null,
    }
    this.verifyId = null
    this.loadingBtn = false
    this.showCouponModal = false
    this.couponConfigForm.coupons = []
  }

  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete([row.id])
      },
    })
  }
  /**
   * 删除单行列表
   */
  deleteRowItem(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDeleteItem(row.id)
      },
    })
  }
  /**
   * 编辑单行列表
   */
  editRowItem(row: any) {}

  handleDeleteItem(id: string) {
    console.log(id)
    distributorApi.deleteDistribution(id).then((res) => {
      console.log(res)
      this.submitFn()
    })
  }
  /**
   * 删除不通过的审核
   */
  handleDelete(ids: string[]) {
    distributorApi.deleteDistributionInfo(ids).then((res) => {
      this.submitFn()
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  /**
   * 批量删除
   */
  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.$Modal.confirm({
        title: '批量删除',
        content: `是否删除已选中的?`,
        onOk: () => {
          let ids = selection.map((item) => {
            return item.id
          })
          this.handleDelete(ids)
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择数据',
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }

  uploadSuccess() {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    this.pageChange(1)
  }
  downloadTemplate() {
    location.href = this.templateUrl
  }

  refresh() {
    this.pageChange(1)
  }
}
